export default (eventHub, { enabled }, store) => {
  if (enabled && typeof window !== 'undefined' && window.dataLayer) {
    eventHub.$on('eventReport', ({ event, ecommerce, ...data }) => {
      if (!ecommerce) ecommerce = {}
      ecommerce.currency = store.getters['ecommerce/getConfigItem']('currency') || 'AUD'

      let pushData = { event, ecommerce, ...data }
      if (event === 'add_to_cart') pushData = singleItemPush('add_to_cart', ecommerce)
      if (event === 'view_wine') pushData = singleItemPush('view_item', ecommerce)
      if (event === 'purchase') pushData = fullTransactionPush('order_placed', ecommerce, store)
      if (event === 'purchase_paid') pushData = fullTransactionPush('purchase', ecommerce, store)
      if (event === 'checkout_options') pushData = fullTransactionPush('begin_checkout', ecommerce, store)
      if (event === 'add_payment_info') pushData = fullTransactionPush('add_payment_info', ecommerce, store)
      if (event === 'add_shipping_info') pushData = fullTransactionPush('add_shipping_info', ecommerce, store)

      // Clear the previous ecommerce object.
      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push(pushData)
    })
  }
}

function singleItemPush(event, ecommerce) {
  return {
    event,
    ecommerce: {
      currency: ecommerce.currency,
      value: ecommerce.price,
      items: [
        {
          item_id: ecommerce.item_id,
          item_name: ecommerce.item_name,
          item_category: ecommerce.wine_type,
          item_category2: ecommerce.wine_series,
          item_category3: ecommerce.wine_varietal,
          item_category4: '',
          item_category5: '',
          item_variant: ecommerce.sku,
          price: ecommerce.price,
          quantity: ecommerce.qty || 1
        }
      ]
    }
  }
}

function fullTransactionPush(event, ecommerce, store) {
  let items = ecommerce.items ?? ecommerce?.transaction?.items ?? []
  if (!Array.isArray(items)) items = Object.values(items)
  return {
    event,
    ecommerce: {
      transaction_id: ecommerce.invoice_no,
      value: ecommerce.total,
      shipping: ecommerce.shipping ?? ecommerce?.transaction?.shipping?.price,
      currency: ecommerce.currency,
      coupon: ecommerce?.transaction?.coupons?.map(coupon => coupon.code).join(', ') ?? undefined,
      payment_type: ecommerce.payment_type ?? '',
      shipping_tier: ecommerce.shipping_tier ?? '',
      items: items.map((item, index) => {
        const baseItem = store.getters['products/findProductByID'](item.item_id ?? item.nid)
        return {
          item_id: baseItem.nid,
          item_name: baseItem.title,
          discount: (item.baseprice || item.cart_base_price) && item.unitprice && item.qty ? ((item.baseprice ?? item.cart_base_price) - item.unitprice) * item.qty : undefined,
          index,
          item_category: baseItem.wine_type,
          item_category2: baseItem.series,
          item_category3: baseItem.varietal instanceof Array ? baseItem.varietal.join(', ') : baseItem.varietal,
          item_category4: '',
          item_category5: '',
          item_variant: baseItem.sku,
          price: item.unitprice ?? item.baseprice ?? item.price ?? baseItem.price,
          quantity: item.quantity ?? item.qty
        }
      })
    }
  }
}
